// Informe para compartir (mail / PDF): HTML con estilos en línea para que se vea bien en cualquier casilla.
import { fmtMin, fmtKey, fmtDow, delta, listDays } from './iaData';

const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const LV = { alerta: ['#dc2626', '#fef2f2', 'Atención'], oportunidad: ['#d97706', '#fffbeb', 'Oportunidad'], info: ['#2563eb', '#eff6ff', 'Dato'], bien: ['#059669', '#ecfdf5', 'Bien'] };

const ROWS = [
  ['horasHombre', 'Horas-hombre', (v) => Math.round(v).toLocaleString('es-AR') + ' h'],
  ['pico', 'Pico de personas', (v) => String(v)],
  ['diasActivos', 'Días con actividad', (v, k) => `${v} de ${k.diasConFotos}`],
  ['casco', 'Personas con casco', (v) => Math.round(v) + '%'],
  ['horasMaquina', 'Horas de máquina trabajando', (v) => v.toFixed(1) + ' h'],
  ['actividad', 'Índice de actividad', (v) => v.toFixed(2)],
  ['inicio', 'Arranque promedio', fmtMin],
  ['fin', 'Cierre promedio', fmtMin],
];

export function reportHtml({ name, rangeLabel, prevLabel, k, k1, items, fromKey, toKey, note, sender }) {
  const kpis = ROWS.map(([key, label, f]) => {
    const n = k[key], p = k1 ? k1[key] : null;
    const d = ['inicio', 'fin'].includes(key) ? null : delta(n, p);
    const col = d == null || Math.abs(d) < 1 ? '#6b7280' : d > 0 ? '#059669' : '#dc2626';
    return `<tr>
      <td style="padding:9px 12px;border-bottom:1px solid #eef0f3;color:#374151">${label}</td>
      <td style="padding:9px 12px;border-bottom:1px solid #eef0f3;text-align:right;font-weight:700;color:#111827">${n == null ? '—' : esc(f(n, k))}</td>
      <td style="padding:9px 12px;border-bottom:1px solid #eef0f3;text-align:right;color:#6b7280">${p == null ? '—' : esc(f(p, k1))}</td>
      <td style="padding:9px 12px;border-bottom:1px solid #eef0f3;text-align:right;font-weight:700;color:${col}">${d == null ? '' : `${d > 0 ? '▲' : d < 0 ? '▼' : '='} ${Math.abs(d).toFixed(0)}%`}</td>
    </tr>`;
  }).join('');

  // Horas-hombre por día en barras (tabla: se ve bien en el mail y en el PDF)
  const days = listDays(fromKey, toKey).slice(-31);
  const max = Math.max(1, ...days.map((d) => k.porDia.get(d)?.hh || 0));
  const bars = days.map((d) => {
    const x = k.porDia.get(d);
    const w = x ? Math.round((x.hh / max) * 100) : 0;
    const wd = new Date(d + 'T12:00:00Z').getUTCDay();
    const finde = wd === 0 || wd === 6;
    return `<tr style="background:${finde ? '#f8fafc' : '#fff'}">
      <td style="padding:2px 8px;font-size:12px;color:#6b7280;white-space:nowrap">${fmtDow(d)} ${fmtKey(d).slice(0, 5)}</td>
      <td style="padding:2px 8px;width:100%"><div style="height:12px;width:${Math.max(w, x ? 1 : 0)}%;background:${x && x.first != null ? '#10b981' : '#e5e7eb'};border-radius:3px"></div></td>
      <td style="padding:2px 8px;font-size:12px;color:#374151;text-align:right;white-space:nowrap">${x ? (x.first != null ? Math.round(x.hh) + ' h · ' + fmtMin(minOf(x.first)) + '–' + fmtMin(minOf(x.last)) : 'sin actividad') : 'sin fotos'}</td>
    </tr>`;
  }).join('');

  const hall = items.map((i) => {
    const [c, bg, lab] = LV[i.level];
    return `<div style="border:1px solid #e5e7eb;border-left:4px solid ${c};border-radius:10px;padding:12px 14px;margin:0 0 10px">
      <span style="display:inline-block;font-size:11px;font-weight:700;color:${c};background:${bg};border-radius:99px;padding:1px 8px">${lab}</span>
      <div style="font-weight:700;font-size:15px;margin:6px 0 2px;color:#111827">${esc(i.titulo)}</div>
      <div style="font-weight:700;color:${c};font-size:14px">${esc(i.dato)}</div>
      <div style="color:#6b7280;font-size:13px;margin:4px 0">${esc(i.detalle)}</div>
      <div style="background:#f9fafb;border-radius:8px;padding:8px 10px;font-size:13px;color:#111827"><b>Qué hacer:</b> ${esc(i.accion)}</div>
    </div>`;
  }).join('');

  return `<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Informe de obra · ${esc(name)}</title>
<style>@media print{body{background:#fff!important}.card{box-shadow:none!important;border:none!important}}</style></head>
<body style="margin:0;background:#f3f4f6;font-family:Poppins,Arial,Helvetica,sans-serif;color:#111827">
<div class="card" style="max-width:720px;margin:0 auto;background:#fff;padding:28px 28px 20px;border-radius:16px;box-shadow:0 1px 3px rgba(0,0,0,.06)">
  <div style="font-size:12px;letter-spacing:.08em;color:#10b981;font-weight:700">LISUAL · INFORME DE OBRA</div>
  <h1 style="margin:6px 0 2px;font-size:24px">${esc(name)}</h1>
  <div style="color:#6b7280;font-size:14px">${esc(rangeLabel)}${prevLabel ? ` · comparado con ${esc(prevLabel)}` : ''}</div>
  ${note ? `<div style="margin:16px 0 0;padding:12px 14px;background:#f0fdf4;border-radius:10px;font-size:14px;white-space:pre-wrap">${esc(note)}${sender ? `<div style="color:#6b7280;font-size:12px;margin-top:6px">— ${esc(sender)}</div>` : ''}</div>` : ''}

  <h2 style="font-size:16px;margin:24px 0 8px">Números del período</h2>
  <table style="width:100%;border-collapse:collapse;font-size:14px">
    <tr style="color:#9ca3af;font-size:11px;text-transform:uppercase;letter-spacing:.05em">
      <td style="padding:6px 12px"></td><td style="padding:6px 12px;text-align:right">Este período</td><td style="padding:6px 12px;text-align:right">Anterior</td><td style="padding:6px 12px;text-align:right">Cambio</td>
    </tr>${kpis}
  </table>

  <h2 style="font-size:16px;margin:26px 0 8px">Qué está pasando y qué hacer</h2>
  ${hall || '<div style="color:#6b7280">Sin hallazgos para este período.</div>'}

  <h2 style="font-size:16px;margin:26px 0 8px">Día por día</h2>
  <div style="color:#6b7280;font-size:12px;margin-bottom:6px">Horas-hombre, arranque y cierre de cada día (fondo gris: fin de semana).</div>
  <table style="width:100%;border-collapse:collapse">${bars}</table>

  <div style="margin-top:26px;padding-top:14px;border-top:1px solid #eef0f3;color:#9ca3af;font-size:12px">
    Datos obtenidos de las fotos de la cámara Lisual de la obra (aprox. una cada 10 minutos), en hora de Argentina. Para ver fotos, detecciones y el mapa de calor, entrá a LisualPro → Inteligencia → Dashboard IA.
  </div>
</div></body></html>`;
}

const minOf = (ms) => Math.floor((((ms - 3 * 3600e3) % 864e5) + 864e5) % 864e5 / 60000);
